import React from 'react';
import { withStyles } from 'material-ui/styles';
import UINumber from '../../core/ui/number.js';

const styles = theme => ({
  date: {
    float: 'right',
  },
  answers: {
    marginLeft: 20,
  },
  answer: {
    marginTop: 10,
  },
});


class QA extends React.Component {
  handleListItemClick(url) {
    if(!url) return;
    var win = window.open(url, '_blank');
    win.focus();

    const uri = '/google/q/this';
    const params = {q : '', url: url};
    this.props.server.get(uri, params, null);
    return false;
  }
  
  render() {
    var key = 0;
    const classes = this.props.classes;
    const data = this.props.data;
    const link = data.link;
    const body = <div>
        <a className={'__link'} href={link}>
          <span className={'__type'}>
            <span>Q&A</span>
            {data.votes &&
              <span>Votes: [<UINumber value={data.votes}/>] </span>
            }
            {data.answercount &&
              <span>Answers: [<UINumber value={data.answercount}/>] </span>
            }
          </span>
        </a>      
        <a className={'__link'} href={link}>
          <span className={'__title'}>{data.title}</span>
        </a>
        <a className={'__link'} href={link}>
          <span className={'__url'}>
            [{data.displayLink}]
          </span>
        </a>                       
        <a className={'__link'} href={link}>
          <span className={'__snippet'}>{data.body}</span>
        </a>        
        {data.answers && 
          <div className={classes.answers}> 
          {data.answers.slice(0,5).map(answer =>
            <div key={key++} className={classes.answer}>
              <a className={'__link'} href={link}>
                <span className={'__type'}>
                  {answer.votes &&
                    <span>Votes: [<UINumber value={answer.votes}/>] </span>
                  }
                </span>
                <span className={'__snippet'}>{answer.body}</span>
              </a>        
            </div>
          )}
          </div>
        }
        {data.keywords &&
          <a className={'__link'} href={link}>
            <span className={'__type'}>keywords: {data.keywords}</span>
          </a>         
        }
      </div>;    

    return (
      body
    );    
  }

}

export default withStyles(styles)(QA);


// WEBPACK FOOTER //
// ./src/search/display/qa.js